module.exports = __webpack_public_path__ + "static/img/2018-03-03 15.40.26.18fadc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2018-03-03 15.40.26.jpg
// module id = WliF
// module chunks = 4